import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=b38930c0&scoped=true&"
import script from "./SettingDialog.vue?vue&type=script&lang=js&"
export * from "./SettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=b38930c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38930c0",
  null
  
)

export default component.exports